import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import { useState, useEffect } from "react";
import Logo from "../images/logo/logo.png";
import Done from "../images/hero/done.png";
import { Link, useLocation } from "react-router-dom";
import strings from '../components/strings.json';

function Receipt() {
  const [lang, setLang] = useState('en');
  const location = useLocation();
  const car = location.state;
  const currency = useState("BD");
  const [cont, setCont] = useState({});
  const random = Math.random();

  useEffect(() => {
    if (lang === "en") {
      setCont(strings.en);
    } else if (lang === "ar") {
      setCont(strings.ar);
    }
    // emailjs.init("ydY8HgV_1DPPYfRpL"); // Public API Key
    // paymentStatus();
  }, [lang])

  const changeLang = () => {
    if (lang === "en") {
      setLang("ar");
      setCont(strings.ar);
      sessionStorage.setItem('lang', "ar");
    } else {
      setLang("en");
      setCont(strings.en);
      sessionStorage.setItem('lang', "en");
    }
  }

  return (
    <>
    <nav>
        {/* desktop */}

        <div className="navbar">
          <div className="navbar__img">
            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
              <img src={Logo} alt="logo-img" />
            </Link>
          </div>
          <ul className="navbar__links">
            <li>
              <Link className="home-link" id={lang} onClick={() => changeLang()}>
                {lang === "en" ? "العربية" : "English"}
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      <section className="about-page">
        <HeroPages name="Order Confirmation" />
        <div className="container">
          <div className="about-main">
            <div className="about-main__text">
              <h2>{cont.Receipt3} {cont.Receipt4}</h2><br></br>
              <h3>{cont.Receipt2}: {car.orderId}</h3>
              <div className="about-main__text__icons">
                <div className="about-main__text__icons__box">
                  <span>
                  <img src={"https://api.hardrockrental.net/imgs/"+car.carType.replace(/\s/g, '').toLowerCase()+'?n='+random} onError={e => { e.currentTarget.src = "https://api.hardrockrental.net/imgs/default.jpg" }} alt="car-icon" />
                    <p>{car.carType} {cont.Receipt1}</p>
                  </span>
                  <span>
                    <p>{cont.Reservation5}: </p>
                  </span>
                  <span>
                    <p>{cont.Reservation20}: </p>
                  </span>
                  <span>
                    <p>{cont.Reservation21}: </p>
                  </span>
                  <span>
                    <p><b>{cont.Reservation9}: </b></p>
                  </span>
                </div>
                <div className="about-main__text__icons__box">
                  <span>
                    <p>{car.subtotal} {currency}</p>
                  </span>
                  <span>
                    <p>{car.servicesCost} {currency}</p>
                  </span>
                  <span>
                    <p>{car.vat} {currency}</p>
                  </span>
                  <span>
                    <p>{car.securityDep} {currency}</p>
                  </span>
                  <span>
                    <p><b>{car.total} {currency}</b></p>
                  </span>
                </div>
              </div>
            </div>
            <div className="about-main__text">
                <img src={Done} style={{ width: "325px" }} alt="logo-img" />
              </div>
          </div>
        </div>
      </section>
      <div className="book-banner">
        <div className="book-banner__overlay"></div>
        <div className="container">
          <div className="text-content">
            <h2>{cont.Receipt7}</h2>
            <span>
              <i className="fa-solid fa-phone"></i>
              <h3>+973 17005001</h3>
            </span>
          </div>
        </div>
      </div>
      <Footer lang={lang} />
    </>
  );
}

export default Receipt;
